
import React from 'react';

export default class Hint extends React.Component {
    render() {
        let classes = ['hint', this.props.className];
        return <div className={classes.join(' ')}>
            <div className="content">
                {this.props.children}
            </div>
        </div>;
    }
}
